import React from "react";
import { Icon, Image } from "semantic-ui-react";

import pumpIcon from "images/icons/pump.png";
import motorIcon from "images/icons/motor.png";
import blowerIcon from "images/icons/blower.png";
import otherMachineIcon from "images/icons/other_machine.png";
import sensorIcon from "images/icons/sensor.png";

export const MENU_ICON = [{ name: "bars" }];
export const CONTEXT_MENU_ICON = [{ name: "caret square down outline" }];

export const ERROR_ICON = [{ name: "warning circle" }];
export const WARNING_ICON = [{ name: "warning circle", color: 'yellow' }];

export const SENSOR_GROUP_ICON = [{ name: "marker" }];

export const DROPDOWN_ICON = [{ name: "dropdown" }];
export const LOCATION_ICON = [{ name: "factory" }];
export const MACHINE_ICON = [{ name: "cog" }];
export const MACHINE_GROUP_ICON = [{ name: "cogs" }];
export const ADD_ICON = [{ name: "add" }];
export const CONFIGURE_ICON = [{ name: "configure" }];
export const ADD_HIERARCHY_ICON = [
  { name: "add" },
  { name: "sitemap", corner: true },
];
export const ADD_ANALYSIS_ICON = [
  { name: "add" },
  { name: "list layout", corner: true },
];
export const SENSOR_ICON = [{ name: "stethoscope" }];
export const FILTER_ICON = [{ name: "filter" }];
export const SEARCH_ICON = [{ name: "search" }];
export const REFRESH_ICON = [{ name: "sync alternate" }];
export const EDIT_ICON = [{ name: "edit" }];
export const ATTACH_ICON = [{ name: "attach" }];
export const CANCEL_ICON = [{ name: "cancel" }];
export const CUSTOM_REFERENCE_ICON = [{ name: "sliders horizontal" }];
export const MACHINE_CUSTOM_REFERENCE_ICON = [
  { name: "sliders horizontal" },
  { name: "cog", corner: true },
];
export const LOG_ENTRY_COMMENT_ICON = [{ name: "comment outline" }];
export const LOG_ENTRY_OBSERVATION_ICON = [{ name: "eye" }];
export const LOG_ENTRY_DIAGNOSIS_ICON = [{ name: "user md" }];
export const LOG_ENTRY_MAINTENANCE_ICON = [{ name: "wrench" }];
export const LOG_ENTRY_UNCATEGORIZED_ICON = [{ name: "question" }];
export const LOG_ENTRY_ANALYSIS_ICON = [{ name: "stethoscope" }];
export const ADD_LOG_ENTRY_ICON = [{ name: "add" }];
export const MACHINE_LOG_ICON = [{ name: "chart line" }];
export const REMOVE_ICON = [{ name: "trash alternate" }];
export const ARCHIVE_ICON = [{ name: "eye slash" }];
export const STATUS_ICON = [{ name: "heartbeat" }];
export const LOGOUT_ICON = [{ name: "log out" }];
export const CHART_ICON = [{ name: "chart bar outline" }];
export const TASK_ICON = [{ name: "file" }];
export const INCOMPLETE_ICON = [{ name: "ban", color: "red" }];
export const CREATED_ICON = [
  { name: "hourglass outline", "data-cy": "Icons__created" },
];
export const PENDING_ICON = [
  { name: "hourglass start", "data-cy": "Icons__pending" },
];
export const RUNNING_ICON = [
  {
    name: "spinner",
    loading: true,
    "data-cy": "Icons__running",
  },
];
export const BLOCKED_ICON = [
  {
    name: "close",
    color: "red",
    "data-cy": "Icons__blocked"
  },
];
export const COMPLETED_ICON = [
  {
    name: "check",
    color: "green",
    "data-cy": "Icons__completed",
  },
];
export const HOME_ICON = [
  {
    name: "home",
    "data-cy": "Icons__home",
  },
];
export const USER_ICON = [
  {
    name: "user",
    "data-cy": "Icons__user",
  },
];
export const COMPLETED_WITH_ERRORS_ICON = [
  {
    name: "question circle outline",
    color: "orange",
    "data-cy": "Icons__completedWithErrors",
  },
];
export const FAILED_ICON = [
  {
    name: "exclamation triangle",
    color: "red",
    "data-cy": "Icons__failed",
  },
];
export const DANGER_ICON = [{ name: "exclamation circle", color: "red" }];
export const UNKNOWN_ICON = [
  {
    name: "question circle",
    color: "red",
    "data-cy": "Icons__unknown",
  },
];
// export const DIAGNOSES_ICON = [{ name: "list layout" }];
export const ANALYSES_ICON = [{ name: "list layout" }];
export const LABEL_ICON = [{ name: "search" }];
export const CIRCLE_ICON = [{ name: "circle" }];
export const REPORT_ICON = [{ name: "save" }];
export const DETAILED_REPORT_ICON = [
  { name: "save" },
  { name: "user md", corner: true },
];
export const RELOAD_ICON = [{ name: "sync alternate" }];
export const RESTART_ICON = [{ name: "redo alternate" }];

export const SELECT_ICON = [
  { name: "square outline", "data-cy": "Icons__select" },
];
export const SELECTED_ICON = [
  {
    name: "check square",
    color: "green",
    "data-cy": "Icons__selected",
  },
];
export const VALIDATED_ICON = [
  {
    name: "check circle",
    color: "blue",
    "data-cy": "Icons__validated",
  },
];
export const ACCEPTABLE_ICON = [
  {
    name: "check circle",
    color: "green",
    "data-cy": "Icons__validated",
  },
];

export const SELECTED_FLAG = [
  {
    name: "flag",
    color: "teal",
    "data-cy": "Icons__flag",
  },
];

export const UNSELECTED_FLAG = [
  {
    name: "flag outline",
    "data-cy": "Icons__flag",
  },
];

export const PREVIOUS_ICON = [{ name: "left arrow" }];
export const NEXT_ICON = [{ name: "right arrow" }];

export const GROUPED_ICON = [{ name: "sitemap" }];

export const toIcon = (icon, groupProps = {}, iconProps = {}) => {
  if (icon.length === 1) {
    return <Icon {...icon[0]} {...groupProps} {...iconProps} />;
  } else {
    return (
      <Icon>
        <Icon.Group {...groupProps}>
          {icon.map((i, index) => (
            <Icon key={index} {...i} {...iconProps} />
          ))}
        </Icon.Group>
      </Icon>
    );
  }
};

export const taskIcon = (task, statusGroups) => {
  if (statusGroups["created"].includes(task.status)) {
    return toIcon(CREATED_ICON);
  }
  if (statusGroups["pending"].includes(task.status)) {
    return toIcon(PENDING_ICON);
  }
  if (statusGroups["running"].includes(task.status)) {
    return toIcon(RUNNING_ICON);
  }
  if (statusGroups["blocked"].includes(task.status)) {
    return toIcon(BLOCKED_ICON);
  }
  if (statusGroups["completed"].includes(task.status)) {
    return toIcon(COMPLETED_ICON);
  }
  if (statusGroups["completed_with_errors"].includes(task.status)) {
    return toIcon(COMPLETED_WITH_ERRORS_ICON);
  }
  if (statusGroups["failed"].includes(task.status)) {
    return toIcon(FAILED_ICON);
  }
  return toIcon(UNKNOWN_ICON);
};


export const FactorySVG = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.33 10L11.67 7V10L17 7V17H1V1H6.33V10Z" stroke="#292F4A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const MachineGroupSVG = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.4323 10.98C17.4723 10.66 17.5023 10.34 17.5023 10C17.5023 9.66 17.4723 9.34 17.4323 9.02L19.5423 7.37C19.7323 7.22 19.7823 6.95 19.6623 6.73L17.6623 3.27C17.5723 3.11 17.4023 3.02 17.2223 3.02C17.1623 3.02 17.1023 3.03 17.0523 3.05L14.5623 4.05C14.0423 3.65 13.4823 3.32 12.8723 3.07L12.4923 0.42C12.4623 0.18 12.2523 0 12.0023 0H8.00228C7.75228 0 7.54228 0.18 7.51228 0.42L7.13228 3.07C6.52228 3.32 5.96228 3.66 5.44228 4.05L2.95228 3.05C2.89228 3.03 2.83228 3.02 2.77228 3.02C2.60228 3.02 2.43228 3.11 2.34228 3.27L0.342281 6.73C0.212281 6.95 0.272281 7.22 0.462281 7.37L2.57228 9.02C2.53228 9.34 2.50228 9.67 2.50228 10C2.50228 10.33 2.53228 10.66 2.57228 10.98L0.462281 12.63C0.272281 12.78 0.222281 13.05 0.342281 13.27L2.34228 16.73C2.43228 16.89 2.60228 16.98 2.78228 16.98C2.84228 16.98 2.90228 16.97 2.95228 16.95L5.44228 15.95C5.96228 16.35 6.52228 16.68 7.13228 16.93L7.51228 19.58C7.54228 19.82 7.75228 20 8.00228 20H12.0023C12.2523 20 12.4623 19.82 12.4923 19.58L12.8723 16.93C13.4823 16.68 14.0423 16.34 14.5623 15.95L17.0523 16.95C17.1123 16.97 17.1723 16.98 17.2323 16.98C17.4023 16.98 17.5723 16.89 17.6623 16.73L19.6623 13.27C19.7823 13.05 19.7323 12.78 19.5423 12.63L17.4323 10.98ZM15.4523 9.27C15.4923 9.58 15.5023 9.79 15.5023 10C15.5023 10.21 15.4823 10.43 15.4523 10.73L15.3123 11.86L16.2023 12.56L17.2823 13.4L16.5823 14.61L15.3123 14.1L14.2723 13.68L13.3723 14.36C12.9423 14.68 12.5323 14.92 12.1223 15.09L11.0623 15.52L10.9023 16.65L10.7023 18H9.30228L8.95228 15.52L7.89228 15.09C7.46228 14.91 7.06228 14.68 6.66228 14.38L5.75228 13.68L4.69228 14.11L3.42228 14.62L2.72228 13.41L3.80228 12.57L4.69228 11.87L4.55228 10.74C4.52228 10.43 4.50228 10.2 4.50228 10C4.50228 9.8 4.52228 9.57 4.55228 9.27L4.69228 8.14L3.80228 7.44L2.72228 6.6L3.42228 5.39L4.69228 5.9L5.73228 6.32L6.63228 5.64C7.06228 5.32 7.47228 5.08 7.88228 4.91L8.94228 4.48L9.10228 3.35L9.30228 2H10.6923L11.0423 4.48L12.1023 4.91C12.5323 5.09 12.9323 5.32 13.3323 5.62L14.2423 6.32L15.3023 5.89L16.5723 5.38L17.2723 6.59L16.2023 7.44L15.3123 8.14L15.4523 9.27ZM10.0023 6C7.79228 6 6.00228 7.79 6.00228 10C6.00228 12.21 7.79228 14 10.0023 14C12.2123 14 14.0023 12.21 14.0023 10C14.0023 7.79 12.2123 6 10.0023 6ZM10.0023 12C8.90228 12 8.00228 11.1 8.00228 10C8.00228 8.9 8.90228 8 10.0023 8C11.1023 8 12.0023 8.9 12.0023 10C12.0023 11.1 11.1023 12 10.0023 12Z"
      fill="#9D9EA9"/>
  </svg>
)

export const MinusIconSVG = (props) => (
  <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 10C5 10.55 5.45 11 6 11H14C14.55 11 15 10.55 15 10C15 9.45 14.55 9 14 9H6C5.45 9 5 9.45 5 10ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
      fill="#D5D5DB"/>
  </svg>
)

export const PlusIconSVG = (props) => (
  <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 5C9.45 5 9 5.45 9 6V9H6C5.45 9 5 9.45 5 10C5 10.55 5.45 11 6 11H9V14C9 14.55 9.45 15 10 15C10.55 15 11 14.55 11 14V11H14C14.55 11 15 10.55 15 10C15 9.45 14.55 9 14 9H11V6C11 5.45 10.55 5 10 5ZM10 0C4.49 0 0 4.49 0 10C0 15.51 4.49 20 10 20C15.51 20 20 15.51 20 10C20 4.49 15.51 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z"
      fill="#9D9EA9"/>
  </svg>
)


const iconProps = {
  width: 20,
  style: {
    display: 'inline-block',
    marginRight: '5px',
    marginBottom: '5px',
    // Removes the annoying corners
    borderRadius: '25px',
  }
}
export const PumpIcon = () => (<Image {...iconProps} src={pumpIcon}/>)
export const MotorIcon = () => (<Image {...iconProps} src={motorIcon}/>)
export const BlowerIcon = () => (<Image {...iconProps} src={blowerIcon}/>)
export const OtherMachineIcon = () => (<Image {...iconProps} src={otherMachineIcon}/>)
export const SensorIcon = () => (<Image {...iconProps} src={sensorIcon}/>)
